/* :: Import Dependencies
{+} ---------------------------------- */
import 'gsap'
import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import 'slick-carousel'
import ScrollMagic from 'scrollmagic'
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

/* :: Import Local
{+} ---------------------------------- */
import Router from './util/Router'
import core from './bootstrap'
import dayCamps from './routes/day-camps'
import skills from './routes/skills'
import findACamp from './routes/find-a-camp'

Alpine.plugin(persist)
window.Alpine = Alpine
global.ScrollMagic = ScrollMagic

/* :: Router Setup
{+} ---------------------------------- */
const routes = new Router({
    core,
    dayCamps,
    skills,
    findACamp,
})

window.onload = () => {
    routes.loadEvents()

    console.log(
        `%cCrafted by https://whiteboard.is`,
        'background: #E2173D; color: #ffffff; font-size: 13px; padding: 4px 8px;',
    )
}
